import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const Title = styled.div`
  font-family: 'Montserrat';
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  color: ${themeGet('colors.black.100')};
  transition: 0.4s all;
  display: inline;
  position: relative;
  cursor: pointer;

  &:hover {
    color: ${themeGet('colors.black.100')};
  }
`;

const Date = styled.span`
  margin-left: 8px;
`;

const Count = styled.span`
  color: ${themeGet('colors.black.80')};
  font-size: 12px;
  margin-left: 16px;

  &:last-child {
    margin-left: 8px;
  }
`;

export class MonthTitle extends React.Component {
  constructor(props) {
    super(props);

    this.state = { clicked: false };

    this.humanizeCount = this.humanizeCount.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleUnclick = this.handleUnclick.bind(this);
  }

  humanizeCount(term, count) {
    return count
      ? `${count} ${term}${count > 1 || count === 0 ? 'S' : ''}`
      : `0 ${term}S`;
  }

  handleClick() {
    this.setState({ clicked: true });
  }

  handleUnclick() {
    this.setState({ clicked: false });
  }

  render() {
    const {
      digestCount,
      isCollapsed,
      monthId,
      toggleCollapsed,
      year,
      tilesCount,
    } = this.props;
    const monthName = moment.monthsShort()[monthId];
    const monthLabel = `${monthName} ${year}`;

    return (
      <Title onClick={toggleCollapsed}>
        <div
          className={`fa-solid fa-sort-down bucket-arrow ${
            isCollapsed ? 'collapse' : ''
          }`}
        />
        <Date>{monthLabel}</Date>
        <Count>{this.humanizeCount('DIGEST', digestCount)}</Count>
        <Count>{this.humanizeCount('TILE', tilesCount)}</Count>
      </Title>
    );
  }
}

export default MonthTitle;
